import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function Hero() {
  return <section className="w-full bg-bg-primary py-12 md:py-20 px-4" data-id="element-78">
      <div className="max-w-7xl mx-auto" data-id="element-79">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-80">
          {/* Left: Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-81">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-text-primary mb-4 md:mb-6 leading-tight" data-id="element-82">
              Arquitectura Empresarial USA: El Ecosistema de los 4 Pilares
            </h1>

            <p className="text-lg md:text-xl lg:text-2xl text-text-secondary mb-6 md:mb-8 leading-relaxed" data-id="element-83">
              Registra, opera y blinda tu empresa en EE.UU. sin ser residente.
              Estructura empresarial completa desde cualquier parte del mundo.
            </p>

            <ul className="space-y-3 md:space-y-4 mb-6 md:mb-10" role="list" data-id="element-84">
              <li className="flex items-start" data-id="element-85">
                <CheckIcon className="h-5 w-5 md:h-6 md:w-6 text-accent-primary mr-2 md:mr-3 mt-0.5 md:mt-1 flex-shrink-0" aria-hidden="true" data-id="element-86" />
                <span className="text-base md:text-lg text-text-primary" data-id="element-87">
                  Arquitectura legal, fiscal y financiera completa
                </span>
              </li>
              <li className="flex items-start" data-id="element-88">
                <CheckIcon className="h-5 w-5 md:h-6 md:w-6 text-accent-primary mr-2 md:mr-3 mt-0.5 md:mt-1 flex-shrink-0" aria-hidden="true" data-id="element-89" />
                <span className="text-base md:text-lg text-text-primary" data-id="element-90">
                  Preparación correcta para bancos y pasarelas de pago
                </span>
              </li>
              <li className="flex items-start" data-id="element-91">
                <CheckIcon className="h-5 w-5 md:h-6 md:w-6 text-accent-primary mr-2 md:mr-3 mt-0.5 md:mt-1 flex-shrink-0" aria-hidden="true" data-id="element-92" />
                <span className="text-base md:text-lg text-text-primary" data-id="element-93">
                  Sistema de cumplimiento y mantenimiento empresarial
                </span>
              </li>
              <li className="flex items-start" data-id="element-94">
                <CheckIcon className="h-5 w-5 md:h-6 md:w-6 text-accent-primary mr-2 md:mr-3 mt-0.5 md:mt-1 flex-shrink-0" aria-hidden="true" data-id="element-95" />
                <span className="text-base md:text-lg text-text-primary" data-id="element-96">
                  Operación empresarial real desde cualquier país
                </span>
              </li>
            </ul>

            <motion.button onClick={() => {
            document.getElementById('purchase')?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full md:w-auto px-6 md:px-8 py-3 md:py-4 bg-accent-primary text-bg-primary font-bold text-base md:text-lg rounded-lg hover:bg-opacity-90 transition-all" aria-label="Acceder al Ecosistema Empresarial" data-id="element-97">
              Acceder al Ecosistema Empresarial
            </motion.button>

            <p className="text-xs md:text-sm text-text-secondary mt-3 md:mt-4" data-id="element-98">
              Acceso inmediato • Ebook PDF • Guía operativa ejecutable
            </p>
          </motion.div>

          {/* Right: Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-first lg:order-last" data-id="element-99">
            <img src="https://cdn.magicpatterns.com/uploads/1dfDuu6s9PDNbf6vN1DsHn/_mockup_arquitectura_USA2.png" alt="Mockup del ebook Arquitectura Empresarial USA" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-100" />
          </motion.div>
        </div>
      </div>
    </section>;
}